import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import { useUserStore } from '@/js/lib/store/user';
import { PERMISSION_ID_POLICY_UPDATE_202403 } from '@/js/data/permission';
import IModal from '@/js/components/molecules/IModal.vue';
import Policy202403 from './update-policy-202403.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    permissionId: {}
  },
  setup(__props: any) {

const props = __props;
const permissionToComponent = {
  [PERMISSION_ID_POLICY_UPDATE_202403]: Policy202403,
};
const userStore = useUserStore();
const { isAgentLogin, isAuthenticated } = userStore;
const activeComponent = computed(() => {
  if (isAgentLogin) {
    return false;
  }

  if (!userStore.hasPermission(props.permissionId)) {
    return permissionToComponent[props.permissionId];
  }

  return false;
});
const shouldNotShowDialog = computed(() => [/^\/news/, /^\/notes/, /^\/privacy/, /^\/rule/].some((pattern) => pattern.test(window.location.pathname)));
const shown = computed(() => isAuthenticated && Boolean(activeComponent.value) && !shouldNotShowDialog.value);

return (_ctx: any,_cache: any) => {
  return (shown.value)
    ? (_openBlock(), _createBlock(IModal, {
        key: 0,
        modelValue: shown.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((shown).value = $event)),
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "lock-scroll": true,
        "show-close": false
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(activeComponent.value)))
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})